//统一的header
import React, { useEffect, useState } from 'react';
import { Header} from 'antd/lib/layout/layout';
import './index.css'
import { Menu ,Image,Col, Row,Button, Drawer} from 'antd';

import {Link} from 'react-router-dom'
import { DEFAULT_SITE_NAVIGATION, fetchSiteNavigation, publicNavigationItems } from '../../siteNavigation';
import {
  UnorderedListOutlined,
  TeamOutlined,
  ProjectOutlined,
  HomeOutlined,
  CoffeeOutlined,
  ExperimentOutlined,
  TwitterOutlined,
  MailOutlined,
  PushpinOutlined,
  ContactsOutlined,
  ReadOutlined,
  UsergroupAddOutlined,
  PayCircleOutlined
} from '@ant-design/icons';

export default function UHeader() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [navigation, setNavigation] = useState(DEFAULT_SITE_NAVIGATION);
  const closeMobileMenu = () => setIsMobileMenuOpen(false);

  useEffect(() => {
    let cancelled = false;
    fetchSiteNavigation()
      .then((data) => {
        if (!cancelled) setNavigation(data);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  const currentConferences = publicNavigationItems(navigation.current_conferences);
  const pastConferences = publicNavigationItems(navigation.past_conferences);
  const workshops = publicNavigationItems(navigation.workshops);
  const publications = publicNavigationItems(navigation.publications);
  const registrationLink = navigation.registration_link?.visible !== false ? navigation.registration_link : null;

  const buildNavItems = (items, keyPrefix, icon) =>
    items.map((item, index) => ({
      key: `${keyPrefix}-${index}`,
      icon,
      label: <a href={item.url}>{item.label}</a>,
    }));

  const registrationItem = registrationLink
    ? { key: 'REG', icon: <PayCircleOutlined />, label: <a href={registrationLink.url}>{registrationLink.label}</a> }
    : null;

  const desktopMenuItems = [
    { key: '1', icon: <HomeOutlined />, label: <Link to="/home">HOME</Link> },
    { key: '2', icon: <ReadOutlined />, label: <Link to="/about">ABOUT AGIST</Link> },
    { key: '3', icon: <TeamOutlined />, label: <Link to="/membership">MEMBERSHIP</Link> },
    {
      key: 'sub1',
      icon: <CoffeeOutlined />,
      label: navigation.conference_menu_title,
      children: [
        ...buildNavItems(currentConferences, 'current-conference', <CoffeeOutlined />),
        {
          key: 'sub1-o',
          icon: <UnorderedListOutlined />,
          label: navigation.past_conferences_title,
          children: buildNavItems(pastConferences, 'past-conference', <CoffeeOutlined />),
        },
        registrationItem,
      ].filter(Boolean),
    },
    {
      key: 'sub2',
      icon: <ExperimentOutlined />,
      label: navigation.workshops_title,
      children: buildNavItems(workshops, 'workshop', <ExperimentOutlined />),
    },
    {
      key: 'sub3',
      icon: <PushpinOutlined />,
      label: navigation.publications_title,
      children: buildNavItems(publications, 'publication', <PushpinOutlined />),
    },
    { key: '4', icon: <ProjectOutlined />, label: <Link to="news">NEWS</Link> },
    { key: '5', icon: <ContactsOutlined />, label: <Link to="contact">CONTACTS</Link> },
  ];

  const mobileMenuItems = [
    { key: 'm-1', icon: <HomeOutlined />, label: <Link to="/home">HOME</Link> },
    { key: 'm-2', icon: <ReadOutlined />, label: <Link to="/about">ABOUT AGIST</Link> },
    { key: 'm-3', icon: <TeamOutlined />, label: <Link to="/membership">MEMBERSHIP</Link> },
    {
      key: 'm-sub1',
      icon: <CoffeeOutlined />,
      label: navigation.conference_menu_title,
      children: [
        ...buildNavItems(currentConferences, 'm-current-conference', <CoffeeOutlined />),
        {
          key: 'm-sub1-o',
          icon: <UnorderedListOutlined />,
          label: navigation.past_conferences_title,
          children: buildNavItems(pastConferences, 'm-past-conference', <CoffeeOutlined />),
        },
        registrationLink
          ? { key: 'm-REG', icon: <PayCircleOutlined />, label: <a href={registrationLink.url}>{registrationLink.label}</a> }
          : null,
      ].filter(Boolean),
    },
    {
      key: 'm-sub2',
      icon: <ExperimentOutlined />,
      label: navigation.workshops_title,
      children: buildNavItems(workshops, 'm-workshop', <ExperimentOutlined />),
    },
    {
      key: 'm-sub3',
      icon: <PushpinOutlined />,
      label: navigation.publications_title,
      children: buildNavItems(publications, 'm-publication', <PushpinOutlined />),
    },
    { key: 'm-4', icon: <ProjectOutlined />, label: <Link to="news">NEWS</Link> },
    { key: 'm-5', icon: <ContactsOutlined />, label: <Link to="contact">CONTACTS</Link> },
    { key: 'm-join', icon: <UsergroupAddOutlined />, label: <Link to="/membership">JOIN AGIST</Link> },
  ];

  return (
    <Header  style={{ padding: 0 ,height:200 }}>
      <div className='card3'>

      
      <div className='card1'>
      <Row align="middle" justify="space-between">
      <Col flex="auto" className="header-logo-col"><Image
          preview={false}
          width={300}
          className="header-logo"
          src={require('../../imgs/AGIST.webp')}
        /> </Col>
      <Col className="mobile-menu-trigger" flex="none">
        <Button
          type="primary"
          shape="circle"
          icon={<UnorderedListOutlined />}
          onClick={() => setIsMobileMenuOpen(true)}
          aria-label="Open navigation"
        />
      </Col>
      <Col className="desktop-actions" flex="none">
      <Row align="middle" justify="end" gutter={8}>
      <Col>
      <a href="mailto:info@agist.org">
        <Button type="dashed" shape="circle" icon={<MailOutlined />} /></a>
        
        </Col>
        <Col>
        <a href="https://twitter.com/DaoAgist">
        <Button type="dashed" shape="circle" icon={<TwitterOutlined />} />
        </a>
      </Col>
      <Col>
      <Link to="/membership">
        <Button type="dashed"  icon={<UsergroupAddOutlined />} >JOIN AGIST</Button>
        </Link>
      </Col>
      </Row>
      </Col>
    </Row>
      
        
      </div>
      </div>
      <div className='card2'>
      <Menu className="ant-layout-header2 desktop-menu" mode="horizontal" defaultSelectedKeys={['1']} items={desktopMenuItems} />
      </div>
      <Drawer
        className="mobile-menu"
        title="Menu"
        placement="right"
        onClose={closeMobileMenu}
        open={isMobileMenuOpen}
        styles={{ body: { padding: 0 } }}
      >
        <Menu mode="inline" onClick={closeMobileMenu} items={mobileMenuItems} />
      </Drawer>
  </Header>
  )
}
